// These are the rules by which the form input fields will be checked against.

import { formHasErrors, formHasValue, noValidation, setFormValues } from "./objectValidation";

/**
 * Criteria:
 * 1) Required
 */
const textTextValidation = (prevConfig, row, value) => {
    // 1)
    if (value.trim() === "") {
        return setFormValues(row, "text", true, "Required");
    }

    return setFormValues(row, "text", false, "");
};

/**
 * Criteria:
 * 1) Required
 */
const textLanguageValidation = (prevConfig, row, value) => {
    // 1)
    if (value.trim() === "") {
        return setFormValues(row, "language", true, "Required");
    }

    return setFormValues(row, "language", false, "");
};

/**
 * Criteria:
 * 1) Required
 */
const audioVoiceValidation = (prevConfig, row, value) => {
    // 1)
    if (value.trim() === "") {
        return setFormValues(row, "_voice", true, "Required");
    }

    return setFormValues(row, "_voice", false, "");
};

// Transcript translation validation
export const TEXT_TRANSLATION_VALIDATION = {
    text: {
        check: textTextValidation
    },
    language: {
        check: textLanguageValidation
    }
};

export const IS_TEXT_TRANSLATION_VALID = (obj) => {
    return !formHasErrors(obj) && formHasValue(obj, "language");
};

// Transcript translation audio validation
export const AUDIO_TRANSLATION_VALIDATION = {
    _voice: {
        check: audioVoiceValidation
    },
    _instructions: {
        check: noValidation
    }
};

export const IS_AUDIO_TRANSLATION_VALID = (obj) => {
    return !formHasErrors(obj) && formHasValue(obj, "meta_data");
};
